import FilterProperty from './FilterProperty';
export default FilterProperty;